import classnames from 'classnames';
import React, { useState, ReactNode } from 'react';
import AnimateHeight from 'react-animate-height';

import '@eika/expand-list-card-style';

import toKebabCaseWithoutNorwegianCharacters from './utils/toKebabCaseWithoutNorwegianCharacters';

const H4 = ({ children, className }): JSX.Element => {
    return <h4 className={className}>{children}</h4>;
};
export interface ExpandListCardElementProps {
    className?: string;
    title: string;
    text: ReactNode;
    id: string;
    customHeaderLevelElement?: () => JSX.Element;
    isActive: boolean;
    dataTrackId?: string;
}

const ExpandListCardElement = ({
    className,
    text,
    title,
    id,
    customHeaderLevelElement,
    isActive,
    dataTrackId,
}: ExpandListCardElementProps): JSX.Element => {
    const Header = customHeaderLevelElement || H4;
    const [isExpanded, setIsExpanded] = useState<boolean>(isActive);

    return (
        <section
            className={classnames('sgw-expand-list-card', className, { expanded: isExpanded })}
            aria-labelledby={`expand-card-${id}`}
        >
            <button
                type="button"
                className="sgw-expand-list-card__header"
                onClick={() => setIsExpanded(!isExpanded)}
                data-track-id={dataTrackId}
                data-track-linkname={dataTrackId && toKebabCaseWithoutNorwegianCharacters(title)}
                data-track-open={dataTrackId && isExpanded}
            >
                <div className="sgw-expand-list-card__header-content">
                    <Header className="sgw-expand-list-card__title-row">
                        <span id={`expand-card-${id}`} className="sgw-expand-list-card__title">
                            {title}
                        </span>
                    </Header>
                </div>
                <span className="screen-reader-text">{isExpanded ? 'Lukk' : ''}</span>
                <span className={classnames('sgw-expand-list-card__arrow', { active: isExpanded })} />
            </button>
            <AnimateHeight height={isExpanded ? 'auto' : 0} contentClassName="sgw-expand-list-card__content">
                {isExpanded && <p className="sgw-expand-list--card__text">{text}</p>}
            </AnimateHeight>
        </section>
    );
};

export default ExpandListCardElement;
